import IdVerificationModal from './IdVerificationModal';

export default IdVerificationModal;
